/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Same_Myna_BubbleInputs */

const fr_bold_same_myna_bubble = /** @type {(inputs: Bold_Same_Myna_BubbleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un role et attribue les permissions correspondantes.`)
};

/**

* @param {Bold_Same_Myna_BubbleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const bold_same_myna_bubble = /** @type {((inputs?: Bold_Same_Myna_BubbleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Same_Myna_BubbleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_bold_same_myna_bubble(inputs)
});